import axios from 'axios';


let pending = []; //声明一个数组用于存储每个ajax请求的取消函数和ajax标识
let cancelToken = axios.CancelToken; //引入取消请求方法
//请求完成后取消该请求，从队列删除
let removePending = (ever) => {
	//console.log(ever)
    for(let p in pending){
        if(pending[p].u === ever.baseURL) { //当前请求在队列中存在时
            pending[p].f(); //执行取消操作
            pending.splice(p, 1); //把这条记录从队列中移除
        }
    }
}
const CancelToken = axios.CancelToken
 
let baseURL
//项目需要，如果是开发环境走本地ip跨域访问（前提是项目有多环境配置文件，配置有代理方法）
if (process.env.REACT_APP_ENV === 'development') {
    baseURL = '/api'
} else {
    //非开发环境下获取配置文件的baseurl
    baseURL = process.env.REACT_APP_BASE_URL
}
// 添加请求拦截器
axios.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
	//console.log(config)
    return config;
  }, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  });
// 添加响应拦截器
axios.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    return response;
  }, function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
  });
// 登录请求方法
axios.interceptors.response.use(undefined, function axiosRetryInterceptor(err) {
    var config = err.config;
    // If config does not exist or the retry option is not set, reject
    if(!config || !config.retry) return Promise.reject(err);
    // Set the variable for keeping track of the retry count
    config.__retryCount = config.__retryCount || 0;
    // Check if we've maxed out the total number of retries
    if(config.__retryCount >= config.retry) {
        // Reject with the error
        return Promise.reject(err);
    }
    // Increase the retry count
    config.__retryCount += 1;
    // Create new promise to handle exponential backoff
    var backoff = new Promise(function(resolve) {
        setTimeout(function() {
            resolve();
        }, config.retryDelay || 1);
    });
    //console.log(config)
    // Return the promise in which recalls axios to retry the request
    return backoff.then(function() {
        return axios(config);
    });
});
const loginreq = (method, url, params,preventRepeat=true,uploadFile=false) => {
	const instance = axios.create({
	    baseURL: baseURL + url,
	    headers: {
	        'Content-Type': 'application/x-www-form-urlencoded'
	        //可添加其他公用参数，比如token等
	    },
	    //设置超时
	  //  timeout: 10 * 1000
	});
	if (preventRepeat) {
	    // request拦截器
		//console.log(preventRepeat)
	    instance.interceptors.request.use(
	        config => {
	            removePending(config);//防止双击多次触发请求
	            config.cancelToken = new cancelToken((c)=>{
	                pending.push({ u: config.baseURL, f: c });
	             });
	            return config;
	        },
	        err => {
	            return Promise.reject(err);
	        }
	    );
	    //response拦截器
	    instance.interceptors.response.use(
	        response => {
	            removePending(response.config);
	            return response;
	        },
	        error => {
	          return Promise.reject(error)
	        }
	    );
	} else {
	    // 拦截器
	    instance.interceptors.request.use(
	        config => {
	            return config;
	        },
	        err => {
	            return Promise.reject(err);
	        }
	    );
	    instance.interceptors.response.use(
	        response => {
	            return response;
	        },
	        error => {
	            return Promise.reject(error)
	        }
	    );
	}
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        params: params,
        traditional: true,
		// timeout: 50* 1000,
		//Connection:keep-alive,
        transformRequest: [
            function(data) {
                let ret = ''
				//console.log(data)
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => res.data);
};

const loginreq2 = (method, url, params,preventRepeat=true,uploadFile=false) => {
	const instance = axios.create({
	    baseURL: baseURL + url,
	    headers: {
	        'Content-Type': 'application/x-www-form-urlencoded'
	        //可添加其他公用参数，比如token等
	    },
	    //设置超时
	   // timeout: 50 * 1000
	});
	if (preventRepeat) {
	    // request拦截器
		//console.log(preventRepeat)
	    instance.interceptors.request.use(
	        config => {
	            removePending(config);//防止双击多次触发请求
	            config.cancelToken = new cancelToken((c)=>{
	                pending.push({ u: config.baseURL, f: c });
	             });
	            return config;
	        },
	        err => {
	            return Promise.reject(err);
	        }
	    );
	    //response拦截器
	    instance.interceptors.response.use(
	        response => {
	            removePending(response.config);
	            return response;
	        },
	        error => {
	          return Promise.reject(error)
	        }
	    );
	} else {
	    // 拦截器
	    instance.interceptors.request.use(
	        config => {
	            return config;
	        },
	        err => {
	            return Promise.reject(err);
	        }
	    );
	    instance.interceptors.response.use(
	        response => {
	            return response;
	        },
	        error => {
	            return Promise.reject(error)
	        }
	    );
	}
	//console.log(params)
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data:params,
        traditional: true,
		// timeout: 50* 1000,
		//Connection:keep-alive,
        transformRequest: [
            function(data) {
                let ret = ''
				//console.log(data)
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => res.data);
};
  const account=()=>{
	  let commonConfig = {};
	  	  commonConfig.host = "http://localhost:8001/";
	  	  commonConfig.ExecuteSQL = commonConfig.host + "YPSoftAppService.asmx/ExecuteJasonApp";
	  	  let dats=[]
	  	return  axios({
	  	      method: 'get',
	  	      url: commonConfig.ExecuteSQL,
	  	      params : {
	  	         v_str_AccountID: '152',
	  	         jsSQL: "{\"SQL\":[{\"select\":\" SELECT * FROM YPSoft_Account.dbo.t_YPSoft_Account  where FTreeNodes='9' \"}]}"
	  	      }
	  	  })
	  	  .then(function (response) {
	  	      //console.log(response);
	  	  		  let arr=response.data.Data.Table
	  	  				  
	  	  		  for(let i=0;i<arr.length;i++){
	  	  			let  Data={"id":arr[i].FID,"LCode":arr[i].FNumber,"name":arr[i].FName}	
	  	  		 dats.push(Data)
	  	  		  }
	  	  		 return dats		
	  	  },res => res.data)
	  	  .catch(function (error) {
	  	     // console.log(error);
	  	  });
  }
	  
// 通用公用方法
const req = (method, url, params) => {
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
           // token: localStorage.getItem('logintoken')
        },
        data: params,
        traditional: true,
        transformRequest: [
            function(data) {
                let ret = ''
				//console.log(data)
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => res.data);
};

export {
	//HttpRequest,
	loginreq2,
    loginreq,
    req,
	httppoo,
	account
}


// WEBPACK FOOTER //
// ./src/api/axiosFun.js